import React, { ReactElement } from 'react';
import Styled from './TableRowContainer.styled';
import { ComponentProps, StyledProps } from './TableRowContainer.types';
import TableData from '../TableDataContainer/TableDataContainer';
import TableHeaderData from '../TableHeadDataContainer/TableHeadDataContainer';

const TableRowContainer: React.FC<ComponentProps & StyledProps> = ({
  children,
  onRowClick,
  ...props
}): ReactElement<ComponentProps & StyledProps> => (
  <Styled {...props} onClick={onRowClick}>
    {props.rowData?.map((e) =>
      props.type === 'head' ? <TableHeaderData value={e} {...props} /> : <TableData value={e} {...props} />,
    )}
    {children}
  </Styled>
);

export default TableRowContainer;
